<svelte:options accessors />

<script lang="ts">
	import type { DropDownConfig } from '$lib/config';
	import { onMount } from 'svelte';
	import type { MDBSelectObj, MDBSelectOptions, mdb } from './types';
	import FormGroup from '../sub_components/FormGroup.svelte';
	import TextInputSub from './TextInputSub.svelte';
	export let Valid = false;
	export let Value: string | undefined = undefined;
	export let Config: DropDownConfig;
	$: OtherSelected = Config.Other && optionSelected == Config.Choices.length + 1;
	//export let MultiSelect: boolean = false;
	let optionSelected: number;
	let selectEl: HTMLElement;
	let selectMDBObj: MDBSelectObj;
	let otherTextComp: TextInputSub;
	let inputEl: HTMLInputElement;
	let mdb;
	onMount(async () => {
		mdb = await import('mdb-ui-kit');
		const { Select } = await import('mdb-ui-kit');
		let selectOpts: MDBSelectOptions = {
			autoSelect: true
		};

		selectMDBObj = Select.getInstance(selectEl);
		//selectMDBObj = new Select(selectEl, selectOpts) as MDBSelectObj;
		// createSelectEventHandler(selectEl, 'valueChange.mdb.select', (e) => {
		// 	if (!OtherSelected) {
		// 		Value = Config.Choices[parseInt(e.value)];
		// 	} else {
		// 	}
		// 	//Value = otherTextComp.Value;
		// 	console.log('Value', Value);
		// 	validate();
		// });

		console.log(otherTextComp);
		console.log(selectMDBObj);
		//inputEl = selectMDBObj._input;
		//console.log(test)
		//selectMDBObj = test.init() as MDBSelectObj;
		//selectMDBObj.open();
		// createSelectEventHandler(selectEl, 'optionSelect.mdb.select', (e) => {
		// 	console.log(e);
		// });
	});
	export function appendData(formData: FormData) {
		let colName = Config.DBCol;
		console.log('setting formData for', colName, 'to', Value);
		formData.append(colName, Value);
	}
	export async function validate() {
		let valid = true;
		if (!Value && Config.Required && !OtherSelected) {
			valid = false;
			// if (OtherSelected) {
			// 	valid = otherTextComp.validate();
			// 	if (valid) {
			// 		Value = otherTextComp.Value;
			// 	} else {
			// 		valid = false;
			// 		console.error('invalid Other value', Config.DBCol);
			// 	}
			// } else {
			//}
		}
		// if (OtherSelected) {
		// 	valid = await otherTextComp.validate();
		// }
		// 	if (valid) {
		// 		Value = otherTextComp.Value;
		// 	} else {
		// 		valid = false;
		// 		console.error('invalid Other value', Config.DBCol);
		// 	}
		// } else if (optionSelected > -1) {
		// 	Value = Options[optionSelected];
		// } else {
		// 	valid = false;
		// 	console.error('no option selected');
		// }
		// if (!Value) {
		// 	console.error('no value defined for', Config.DBCol);
		// 	valid = false;
		// }
		Valid = valid;
		Valid ? setValid() : Config.Required ? setInvalid() : setNeutral();
		return Valid;
	}
	export function focus() {
		selectEl.focus();
	}
	function setNeutral() {
		selectEl.classList.remove('is-valid');
		selectEl.classList.remove('is-invalid');
		showInvalidFeedback = false;
	}

	function setValid() {
		selectEl.classList.add('is-valid');
		selectEl.classList.remove('is-invalid');
		showInvalidFeedback = false;
	}

	function setInvalid() {
		selectEl.classList.remove('is-valid');
		selectEl.classList.add('is-invalid');
		showInvalidFeedback = true;
	}
	let showInvalidFeedback = false;

	function handleSelectChange(event: Event) {
		optionSelected = parseInt(event.target.value);
		if (optionSelected == -1) {
			Value = undefined;
		} else if (OtherSelected) {
			// Value will be set from otherTextComp
			setNeutral();
			Value = undefined;
		} else {
			Value = Config.Choices[optionSelected];
		}
		validate();
	}
</script>

<FormGroup {Config}>
	{#if Config.Title}
		<div class="comp-title">{Config.Title}</div>
	{/if}
	<div class="col">
		<select
			class="form-select"
			bind:this={selectEl}
			bind:value={optionSelected}
			required={Config.Required}
			on:change={handleSelectChange}
		>
			<option value="-1" hidden selected>Select an option</option>
			{#each Config.Choices as option, i}
				<option value={i}>{option}</option>
			{/each}
			{#if Config.Other}
				<option value={Config.Choices.length + 1}>Other</option>
			{/if}
		</select>
		<div class="invalid-feedback" class:hidden={!showInvalidFeedback}>Required value</div>
	</div>
	{#if OtherSelected}
		<div class="select-custom-content">
			<TextInputSub
				InsideTitle={'Your ' + Config.Title}
				bind:this={otherTextComp}
				OnValid={() => {
					Value = otherTextComp.Value;
					setValid();
				}}
			/>
		</div>
	{/if}
</FormGroup>

<style>
</style>
